<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h2 class="purple bold">Notificações</h2>
      </b-col>
    </b-row>

    <b-row class="mt-50">
      <b-col>
        <DataTable
          :items="notifications"
          :fields="fields"
          :busy="!isRequestSend"
          :row-class="deadlineStatusClass"
          clickable
          empty-text="Nenhuma notificação encontrada"
          class="list-top"
          @row-clicked="viewNotification"
        >
          <template #cell(message)="{ item }">
            <div class="message-cell">
              <p class="message-text" :title="item.message">
                {{ truncatedMessage(item.message) }}
              </p>
              <div class="cell-meta">
                <span>{{ metaText(item) }}</span>
              </div>
            </div>
          </template>

          <template #cell(student)="{ item }">
            <div class="student-cell">
              <p class="student-name">{{ studentName(item) }}</p>
              <div class="cell-meta">
                <span v-if="item.Subject">{{ item.Subject.designation }}</span>
                <span v-if="item.Cycle" class="badge badge-ciclo">{{
                  item.Cycle.name
                }}</span>
              </div>
            </div>
          </template>

          <template #cell(deadline)="{ item }">
            <p>{{ item.deadline ? formatDeadline(item.deadline) : "-" }}</p>
          </template>

          <template #cell(resolve)="{ item }">
            <button
              type="button"
              class="resolve-btn"
              :disabled="item.resolved_at > 0"
              @click.stop="confirmResolve(item)"
            >
              {{ item.resolved_at > 0 ? "Resolvido" : "Resolver" }}
            </button>
          </template>
        </DataTable>

        <b-row class="align-center" v-if="count > 0 && isRequestSend">
          <b-pagination
            v-model="page"
            :per-page="perPage"
            :total-rows="count"
            @change="changePage"
            aria-controls="notificationsInboxList"
            last-text
            first-text
          >
            <template #prev-text>
              <LeftArrowIcon class="left" />
            </template>
            <template #next-text>
              <LeftArrowIcon />
            </template>
          </b-pagination>
        </b-row>
      </b-col>
    </b-row>

    <TeacherNotificationInboxDetail :notification="selectedNotification" />
  </b-container>
</template>

<script>
import moment from "moment-timezone";
import { mapActions } from "vuex";
import TeacherNotificationInboxService from "@/services/teacherNotificationInbox.service";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import TeacherNotificationInboxDetail from "@/components/modals/TeacherNotificationInboxDetail.vue";
import DataTable from "@/components/table/DataTable.vue";
import { deadlineState } from "@/utils/notificationDeadline";

export default {
  name: "professor-notificacoes-inbox",

  components: {
    LeftArrowIcon,
    TeacherNotificationInboxDetail,
    DataTable,
  },

  data() {
    return {
      notifications: [],
      isRequestSend: false,
      selectedNotification: null,

      page: 1,
      perPage: 10,
      count: 0,

fields: [
        {
          key: "message",
          label: "Mensagem",
          thStyle: { width: "45%" },
          tdStyle: { width: "45%" },
        },
        {
          key: "student",
          label: "Aluno/Ciclo",
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
        },
        { key: "deadline", label: "Prazo" },
        { key: "resolve", label: "Status" },
      ],

      breadcrumb: [
        {
          text: "Notificações",
          href: "/professor/notificacoes",
          active: true,
        },
      ],
    };
  },

  methods: {
    ...mapActions({
      refreshTeacherPendingNotifications:
        "shared/refreshTeacherPendingNotifications",
    }),

    async fetchNotifications() {
      this.isRequestSend = false;

      try {
        const response = await TeacherNotificationInboxService.getAll({
          page: this.page,
          pageSize: this.perPage,
        });

        this.notifications = response.data.notifications;
        this.count = response.data.count;
      } catch (error) {
        this.notifications = [];
        this.count = 0;
      }

      this.isRequestSend = true;
    },

    changePage(page) {
      this.page = page;
      this.fetchNotifications();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    truncatedMessage(message) {
      return message.length > 80 ? message.substring(0, 80) + "..." : message;
    },

    confirmResolve(notification) {
      const hasStudentName = this.studentName(notification) && this.studentName(notification) !== '---';
      const messageText = hasStudentName ? `Marcar como resolvida a notificação de ${this.studentName(notification)}` : "Marcar como resolvida referente ao ciclo?";
      this.$swal
        .fire({
          title: "Resolver notificação?",
          text: messageText,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, resolver!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.markResolved(notification);
          }
        });
    },

    async markResolved(notification) {
      if (notification.resolved_at > 0) {
        return;
      }

      try {
        const response = await TeacherNotificationInboxService.markResolved(
          notification.id
        );
        notification.resolved_at = response.data.resolved_at;
        this.refreshTeacherPendingNotifications();
      } catch (error) {
        return
      }
    },

    viewNotification(notification) {
      this.selectedNotification = notification;
      this.$bvModal.show("teacher-notification-inbox-detail");
    },

    metaText(notification) {
      const date = moment
        .tz(notification.created_at, "America/Sao_Paulo")
        .format("DD/MM/YYYY");
      const name = notification.Creator ? notification.Creator.name : "";
      return `${date} • ${name || "—"}`;
    },

    studentName(notification) {
      const name =
        notification.Student && notification.Student.User
          ? notification.Student.User.name
          : "";
      return name || "---";
    },

    formatDeadline(date) {
      return moment.tz(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    deadlineStatusClass(notification) {
      const state = deadlineState(notification);

      if (state === "overdue") {
        return "row-danger";
      }

      if (state === "warning") {
        return "row-warning";
      }

      return "";
    },
  },

  created() {
    this.fetchNotifications();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}

.resolve-btn {
  background-color: $blue;
  border: none;
  border-radius: 5px;
  color: $white;
  cursor: pointer;
  font-size: 14px;
  font-weight: $bold;
  line-height: 20px;
  padding: 5px 14px;

  &:hover:not(:disabled) {
    background-color: $green3;
    color: $white;
  }

  &:disabled {
    background-color: $purple;
    cursor: default;
    opacity: 1;
  }
}

.message-cell,
.student-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-text,
.student-name {
  color: $grey3;
  font-weight: 600;
  line-height: 1.4;
  font-size: 14px;
}

.cell-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  color: $grey4;
  font-size: 13px;

  .badge {
    font-size: 12px;
    padding: 2px 10px;
  }
}
</style>
